import React, { useEffect } from 'react';
import { ExternalLink } from 'lucide-react';
import { useAdSurfaceAndSlot } from '../../hooks/useAdSurfaceAndSlot';
import { isValidAdDestination } from '../../utils/adDestinationUrl';
import { logHomeAds } from '../../config/ads';
import {
  CardRoot,
  CardBgImage,
  CardBgOverlay,
  CardContent,
  RowTop,
  AdTag,
  Sponsor,
  CardTitle,
  CardDesc,
  CtaRow,
} from './PromoAdCard.styled';

export default function PromoAdCard({ ad, pageKey, onImpression, onLinkClick }) {
  const { loaded, slotVisible } = useAdSurfaceAndSlot(pageKey);
  useEffect(() => {
    if (!onImpression || !ad?.managedCampaignId) return;
    onImpression();
  }, [onImpression, ad?.managedCampaignId]);

  useEffect(() => {
    if (!logHomeAds || pageKey !== 'home') return;
    const willRender = loaded && slotVisible && !!ad;
    console.log('[simimovies/ads/home] PromoAdCard', {
      willRender,
      loaded,
      slotVisible,
      hasAd: !!ad,
      managedCampaignId: ad?.managedCampaignId ?? null,
      title: ad?.title ?? null,
    });
  }, [loaded, slotVisible, ad, pageKey]);

  if (!loaded || !slotVisible || !ad) return null;

  const dest = isValidAdDestination(ad.url);
  const href = dest ? ad.url : '#';
  const hasImage = Boolean(ad.image);
  const onClick = (e) => {
    if (!dest) e.preventDefault();
    else onLinkClick?.(e);
  };

  return (
    <CardRoot
      href={href}
      onClick={onClick}
      target={dest ? '_blank' : undefined}
      rel={dest ? 'noopener noreferrer sponsored' : undefined}
    >
      {hasImage ? (
        <>
          <CardBgImage $src={ad.image} />
          <CardBgOverlay />
        </>
      ) : null}
      <CardContent>
        <RowTop>
          <AdTag>Ad</AdTag>
          <Sponsor>{ad.sponsor}</Sponsor>
        </RowTop>
        <CardTitle $hasImage={hasImage}>{ad.title}</CardTitle>
        <CardDesc $hasImage={hasImage}>{ad.description}</CardDesc>
        <CtaRow>
          {ad.cta} <ExternalLink size={12} />
        </CtaRow>
      </CardContent>
    </CardRoot>
  );
}
